import { Skeleton } from '@chakra-ui/react';
import { useFetchUser } from '../../hooks/user/useFetchUser';


export const SalesmanName = () => {
  const {user} = useFetchUser();
  if (!user) return <Skeleton h='24px' w='100%' />;
  return <>{user.last_name}{user.first_name}</>;
};